import { PropsWithChildren, ReactNode } from "react";
import { LoadingButton } from "@/components/loading-button";

interface OnboardingFormContainerProps extends PropsWithChildren {
  title: string;
  subtitle?: string | ReactNode;
  isError?: boolean;
  errorMessage?: string;
  buttonLabel?: string;
  buttonType?: "submit" | "button";
  onButtonClick?: () => void;
  isButtonDisabled?: boolean;
  isButtonPending?: boolean;
  leadingContent?: ReactNode;
}

const DEFAULT_ERROR_MESSAGE = "An error occurred. Please try again later.";

export const OnboardingFormContainer = ({
  title,
  subtitle,
  leadingContent,
  children,
  isError,
  errorMessage = DEFAULT_ERROR_MESSAGE,
  buttonLabel,
  buttonType = "button",
  onButtonClick,
  isButtonDisabled = false,
  isButtonPending = false,
}: OnboardingFormContainerProps) => {
  return (
    <div className="flex min-h-0 w-full flex-1 flex-col">
      <div className="mb-6">
        {leadingContent && <div className="mb-6">{leadingContent}</div>}
        <div className="mb-2 text-xl font-medium">{title}</div>
        {subtitle && (
          <div className="text-sm text-muted-foreground">{subtitle}</div>
        )}
      </div>
      {children}
      {isError && (
        <div className="mt-2 text-xs text-destructive">{errorMessage}</div>
      )}
      {buttonLabel && (
        <LoadingButton
          type={buttonType}
          className="!mt-8"
          onClick={onButtonClick}
          disabled={isButtonDisabled}
          isPending={isButtonPending}
        >
          {buttonLabel}
        </LoadingButton>
      )}
    </div>
  );
};
